let model = {};

// dữ liệu form
model.dataForm = {
  id: undefined, // optional - Mã tự sinh
  name: undefined, // required, minLength: 1 - Tên socket
  address: undefined, // required, minLength: 1 - IP/domain của socket
  port: undefined, // required, min: 1, max: 65535 - Port của socket
};
model.tableRules = {
  lengthMenu: [10, 20, 50, 100],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 20,
  offset: 0,
  sort: "address",
  defaultSort: ["address", "ascending"],
  fields: "id,name,address,port",
  filters: "",
  dataSearch: {
    value: {
      name: "",
      address: "",
      port: "",
    },
    operator: {
      name: ":regex_i:",
      address: ":regex_i:",
      port: "",
    },
  },
};

export default model;
